// extracted by mini-css-extract-plugin
export default {"collapse":"_0ddgn"};